/* eslint-disable jsx-a11y/anchor-has-content */
import * as React from "react";
import "./HeroLiveStream.scss";

interface IHeroLiveStreamProps {}

export const HeroLiveStream: React.FunctionComponent<IHeroLiveStreamProps> = (
  props
) => {
  return (
    <div className="HeroLiveStream">
      <div className="HeroLiveStream__content">
        <h2>Watch the live press conference</h2>
        <a href="https://youtu.be/bZM_ZzxihTg" target="_blank" rel="noreferrer" ></a>
      </div>
    </div>
  );
};
